import axios from 'axios';
import { fetchManagerAccessToken, getManagerAccessToken, isExpired } from '../../app/tokens';
import config from '../../config';
import type { TAxiosInterceptorResponseError } from './rtk-query.types';
import { isTAxiosResponseError } from './rtk-query.types';

const base = config.VITE_BACKEND_URL;
const httpClient = axios.create({ baseURL: base });

httpClient.interceptors.request.use(async (config) => {
  let token = getManagerAccessToken();
  if (!token || isExpired(token)) {
    try {
      const { accessToken } = await fetchManagerAccessToken();
      token = accessToken;
    } catch (e) {
      console.log('Refresh failed:', (e as Error).message);
      if (window.self == window.top) {
        window.location.assign('/login');
      }
    }
  }
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

httpClient.interceptors.response.use(
  (res) => {
    return res;
  },

  (error): Promise<TAxiosInterceptorResponseError> => {
    if (isTAxiosResponseError(error)) {
      return Promise.reject({
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data,
        message: error.response.data?.message,
      });
    }
    return Promise.reject({
      status: -1,
      statusText: 'Unknown error!',
      data: {},
      message: 'Unknown error!',
    });
  },
);

export default httpClient;
